import React from 'react';
import ni from '../../../assets/Images/team_2019/nikhil_hCo-CSG5PX.jpeg';
import yi from '../../../assets/Images/team_2019/yogesh_88Yi95lhuI.jpg';
import aai from '../../../assets/Images/team_2019/aditya_HTaVSc1Z6.jpeg';
import pgi from '../../../assets/Images/team_2019/gupta_Qa6ihOVEaN.jpg';
import pmi from '../../../assets/Images/team_2019/prashant_S_ucExkuun.jpg';
import spi from '../../../assets/Images/team_2019/shiv_2ccRHKSu8B.jpeg';
import hki from '../../../assets/Images/team_2019/hksingh_4aDFb7fXl3.jpeg';
import mpi from '../../../assets/Images/team_2019/patil_MjZK8A03TF.jpg';
import sai from '../../../assets/Images/team_2019/shraddha_wnl1qQt0kD.jpg';
import aji from '../../../assets/Images/team_2019/aditya_0kKz5IBtF5.jpg';
import hti from '../../../assets/Images/team_2019/hmt_a9R7Tt5wZ.jpg';
import jvi from '../../../assets/Images/team_2019/jayesh_9qhQP8jcEl.jpg';
import ci from '../../../assets/Images/team_2019/chandrahas_DGl02m5rl.jpg';
import dbi from '../../../assets/Images/team_2019/dhruvi_dlDHU96UwE.jpg';
import rsi from '../../../assets/Images/team_2019/rajat_-PJOszOsi.jpg';
import hsi from '../../../assets/Images/team_2019/het_OJx1EdNy2.jpeg';
import dyi from '../../../assets/Images/team_2019/dev_plpgSWUnNG.jpg';
import styles from '../Services2/Services2.module.scss';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';
import EmailIcon from '@material-ui/icons/Email';
import InstagramIcon from '@material-ui/icons/Instagram';
import Image from 'react-bootstrap/Image';
import theme from '../../../state/theme';

export default () => {
    return (
        <>
            <div className={styles.maindiv} style={{ marginTop: "40px" }}>
                <div className={styles.container_two} >
                    <div  >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Secretary</p>
                            <div className={styles.wrapper}>
                                <Image src={ni} />
                                <h2 className={styles.nameHeading}>Nikhil Vyas</h2>
                                <ul>
                                    <li> <a href="mailto:nikhilvyas1998@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/nikhil-vyas-4a1a81148/" target="_blank"> <LinkedInIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/nikhil.vyas.9889" target="_blank"> <FacebookIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Joint Secretary</p>
                            <div className={styles.wrapper}>
                                <Image src={yi} />
                                <h2 className={styles.nameHeading}>Yogesh Pandey</h2>
                                <ul>
                                    <li> <a href="mailto:yogi.sam72@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/yogesh-pandey-61aa11190" target="_blank"> <LinkedInIcon /> </a></li>
                                    {/* <li> <a href="https://github.com/ektaarora3501" target="_blank"> <GitHubIcon />  </a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Event</p>
                            <div className={styles.wrapper}>
                                <Image src={aai} />
                                <h2 className={styles.nameHeading}>Aditya Agrawal</h2>
                                <ul>
                                    <li> <a href="mailto:aggarwaladitya.ai@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/profile.php?id=100006279105395" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="http://www.linkedin.com/in/aditya-ai" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Finanace</p>
                            <div className={styles.wrapper}>
                                <Image src={pgi} />
                                <h2 className={styles.nameHeading}>Pratyush Gupta</h2>
                                <ul>
                                    <li> <a href="mailto:pratyushgupta190@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://m.facebook.com/pratyush.gupta.963" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/pratyush-gupta-917328192" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Operations Head</p>
                            <div className={styles.wrapper}>
                                <Image src={pmi} />
                                <h2 className={styles.nameHeading}>Prashant Meena</h2>
                                <ul>
                                    <li> <a href="mailto:prashantmeenajaipur@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/prashant.meena160316" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/prashant-meena-622397191" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Marketing Head</p>
                            <div className={styles.wrapper}>
                                <Image src={spi} />
                                <h2 className={styles.nameHeading}>Shivpoojan Saini</h2>
                                <ul>
                                    <li> <a href="mailto:sainishivpoojan1@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/shivpoojan.saini.503" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/shivpoojan-saini-288473189/" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Public Relation</p>
                            <div className={styles.wrapper}>
                                <Image src={hki} />
                                <h2 className={styles.nameHeading}>Himanshu Kumar</h2>
                                <ul>
                                    <li> <a href="mailto:himanshu03.gkp@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://m.facebook.com/himanshukumar.singh.7773?ref=bookmarks" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/himanshu-singh-7708ba176" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Public Relation</p>
                            <div className={styles.wrapper}>
                                <Image src={mpi} />
                                <h2 className={styles.nameHeading}>Mansi Patil</h2>
                                <ul>
                                    <li> <a href="mailto:mansipatil775@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/mansi.patil.77" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="http://www.linkedin.com/in/mansi-patil-2601" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Corporate Relations</p>
                            <div className={styles.wrapper}>
                                <Image src={sai} />
                                <h2 className={styles.nameHeading}>Shraddha</h2>
                                <ul>
                                    {/* <li> <a href="" target="_blank"> <EmailIcon /> </a></li> */}
                                    <li> <a href="https://www.facebook.com/ShraddhaAgg" target="_blank"> <FacebookIcon /> </a></li>
                                    {/* <li> <a href="" target="_blank"> <LinkedInIcon />  </a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Corporate Relations</p>
                            <div className={styles.wrapper}>
                                <Image src={aji} />
                                <h2 className={styles.nameHeading}>Aditya Jaiswal</h2>
                                <ul>
                                    <li> <a href="https://github.com/iam844" target="_blank"> <GitHubIcon /> </a></li>
                                    {/* <li> <a href="" target="_blank"> <FacebookIcon /> </a></li> */}
                                    <li> <a href="https://www.linkedin.com/in/iam844" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Design Team</p>
                            <div className={styles.wrapper}>
                                <Image src={hti} />
                                <h2 className={styles.nameHeading}>Himadri Tanya</h2>
                                <ul>
                                    <li> <a href="mailto:himadritanya4@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/tanya.h.5011" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/himadri-tanya-38aa47186" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Design Head</p>
                            <div className={styles.wrapper}>
                                <Image src={jvi} />
                                <h2 className={styles.nameHeading}>Jayesh</h2>
                                <ul>
                                    <li> <a href="mailto:jayeshh45@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://instagram.com/jayeshh45?igshid=1v25bdxpxrllw" target="_blank"> <InstagramIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/jayeshh45" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Design Team</p>
                            <div className={styles.wrapper}>
                                <Image src={ci} />
                                <h2 className={styles.nameHeading}>Chandrahas</h2>
                                <ul>
                                    {/* <li> <a href="" target="_blank"> <EmailIcon /> </a></li> */}
                                    <li> <a href="https://www.facebook.com/chandrahas.chandu.1" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/chandrahas-paidi-96053b194" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Web Team</p>
                            <div className={styles.wrapper}>
                                <Image src={dbi} />
                                <h2 className={styles.nameHeading}>Dhruvi Butti</h2>
                                <ul>
                                    <li> <a href="https://github.com/Dhruvi16" target="_blank"> <GitHubIcon /> </a></li>
                                    {/* <li> <a href="" target="_blank"> <FacebookIcon /> </a></li> */}
                                    <li> <a href="https://www.linkedin.com/in/dhruvi-butti-bb6196149/" target="_blank"> <LinkedInIcon />  </a></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Web Team</p>
                            <div className={styles.wrapper}>
                                <Image src={dyi} />
                                <h2 className={styles.nameHeading}>Devanshu Yadav</h2>
                                <ul>
                                    <li> <a href="mailto:devanshu.yadav1910@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://github.com/Blackwatch1910" target="_blank"> <GitHubIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/devanshu-yadav-9766ba111/" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Web Team</p>
                            <div className={styles.wrapper}>
                                <Image src={rsi} />
                                <h2 className={styles.nameHeading}>Rajatverdhan</h2>
                                <ul>
                                    {/* <li> <a href="mailto:devanshu.yadav1910@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://github.com/Blackwatch1910" target="_blank"> <GitHubIcon /> </a></li> */}
                                    <li> <a href="http://www.linkedin.com/in/rajat-sharma-274752170/" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div >
                        <div className={styles.card}>
                            <p className={styles.post_heading}>Social Media Head</p>
                            <div className={styles.wrapper}>
                                <Image src={hsi} />
                                <h2 className={styles.nameHeading}>Het Shah</h2>
                                <ul>
                                    <li> <a href="mailto:hshah99.a@gmail.com" target="_blank"> <EmailIcon /> </a></li>
                                    <li> <a href="https://www.facebook.com/shah.het.92" target="_blank"> <FacebookIcon /> </a></li>
                                    <li> <a href="https://www.linkedin.com/in/het-shah-a007401a1" target="_blank"> <LinkedInIcon />  </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}